<div class="publish-flow-beta">
    <div class="modal-header" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="start center">
        <button class="icon-back mr-3 d-none d-medium" mat-button matPreffix mat-icon-button aria-label="Back"
            mat-dialog-close>
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <h2>{{'flows.modal.publishFlowBeta.title' | translate}}</h2>
        <div class="close" mat-dialog-close>
            <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
        </div>
    </div>
    <div class="modal-content mob-fixed-button">
        <div class="text-content" fxLayout="column" fxLayoutAlign="start center">
            <div class="icon mb-4" fxLayout="row" fxLayoutAlign="center center">
                <mat-icon class="ic-34 fc-6" aria-hidden="false" aria-label="publish">publish</mat-icon>
            </div>
            <p class="fs-18">{{'flows.modal.publishFlowBeta.description' | translate}}</p>
            <span class="fs-14 fc-6">
                {{'flows.modal.publishFlowBeta.text-one' | translate}}
                <span class="fc-3">{{model.user.email}}</span>
                {{'flows.modal.publishFlowBeta.text-two' | translate}}
            </span>
        </div>
    </div>
    <div class="modal-footer" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h-medium">
            <a class="close">{{'modal-alert.cancel' | translate}}</a>
        </div>
        <button mat-flat-button color="primary" mat-dialog-close> 
            {{'flows.modal.publishFlowBeta.confirm' | translate}}
        </button>
    </div>
</div>